export {default as DataTable} from './data-table.vue'
export {default as TableHead} from './table-head.vue'
export {default as Column} from 'primevue/column'

export {default as TableScrollable} from './scrollable-table.vue'
